// extracted by mini-css-extract-plugin
export default {"news-by-locations":"styles-module__news-by-locations___AlDOo","news-sections":"styles-module__news-sections___k5RfN"};